module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/096-mozambique-caecf16aa1be8730769ab7d6d6297dd3.svg";